import AuthGuard from '../components/AuthGuard';
import InnerLayout from '../components/InnerLayout';

export default function GroupPage() {
  return (
    <div>
      <AuthGuard />
      <InnerLayout title="官方群聊" backHref="/profile">
        <div className="mx-auto max-w-md px-4">
          <div className="-mt-5 rounded-2xl bg-white p-4 shadow">
            <div className="text-sm">加入官方群聊</div>
            <div className="mt-2 text-[12px] text-gray-600">获取最新通知与活动信息</div>
          </div>
          <div className="mt-4 rounded-2xl bg-white p-4 shadow">
            <a href="#" className="block w-full rounded-xl bg-red-600 py-3 text-center text-white">立即加入</a>
          </div>
        </div>
      </InnerLayout>
    </div>
  );
}